import { render, staticRenderFns } from "./BackgroundCarousel.vue?vue&type=template&id=21343047&scoped=true"
import script from "./BackgroundCarousel.vue?vue&type=script&lang=js"
export * from "./BackgroundCarousel.vue?vue&type=script&lang=js"
import style0 from "./BackgroundCarousel.vue?vue&type=style&index=0&id=21343047&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21343047",
  null
  
)

export default component.exports